const ad = state => state.ad

export default {
  ad

}
